<template>
    <modal dialog="modal-lg" class="dark-top" :footer="true">

        <div slot="title">
            <h2>Advanced Settings</h2>
        </div>

        <div slot="body">
            <div class="container">

                <!-- Title -->
                <div class="pt-4 fs-large dark bold">
                    Select the information you want to be visible to your customers.
                </div>

                <!-- options -->
                <div class="row py-4">

                    <div class="col-sm-4 d-flex align-items-center py-2">
                        <checkbox v-model="getSelectedWidgetCategory.isToShowDuration"></checkbox>
                        Show Duration
                    </div>

                    <div class="col-sm-4 d-flex align-items-center py-2">
                        <checkbox v-model="getSelectedWidgetCategory.isToShowTotalAvailability"></checkbox>
                        Show total availability
                    </div>

                    <div class="col-sm-4 d-flex align-items-center py-2">
                        <checkbox v-model="getSelectedWidgetCategory.isToShowActivityName"></checkbox>
                        Show Activity Name
                    </div>

                    <div class="col-sm-4 d-flex align-items-center py-2">
                        <checkbox v-model="getSelectedWidgetCategory.isToShowResourceName"></checkbox>
                        Show resource name
                    </div>

                    <div class="col-sm-4 d-flex align-items-center py-2">
                        <checkbox v-model="getSelectedWidgetCategory.isToShowGroupScheduleTitle"></checkbox>
                        Show schedule title
                    </div>

                </div>
            </div>

        </div>

        <div slot="footer" class="d-flex flex-all">
            <button type="button" class="btn cancel wider" @click="cancel">Cancel</button>
            <button type="button" class="btn ok wider" @click="save">Save</button>
        </div>
    </modal>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import Modal from './Modal'
    export default {
        data: function() {
            return {
            }
        },
        computed: {
            ...mapGetters([
                'getSelectedWidgetCategory'
            ])
        },
        methods: {
            ...mapActions([
                'closeModal'
            ]),
            cancel: function() {
                this.closeModal();
            },
            save: function() {
                this.closeModal();
            }
        },
        components: {
            Modal,
        }
    }
</script>



// WEBPACK FOOTER //
// WidgetAdvanced.vue?37fb175d